import React from 'react';
import { HeartIcon, QuoteIcon } from 'lucide-react';
import { fullTestimonials } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function FullTestimonials() {
  return <section className="mx-auto max-w-6xl px-4 py-14 md:py-16" data-id="element-112" data-mp="3dggd5qsue9yq">
      <Eyebrow data-id="element-113" data-mp="3idq3d8o22pnm">
        <span className="inline-flex items-center gap-2" data-id="element-114" data-mp="3ie9loqhmbg26">
          <HeartIcon aria-hidden="true" className="h-4 w-4" data-id="element-115" data-mp="2lp0jxdws5ozj" /> Más profesoras que ya lo tienen
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-116" data-mp="2pr5ag3rxm5hy">
        Lo que cambió en sus clases <span className="text-gold" data-id="element-117" data-mp="2prx59cdpfz76">desde la primera semana</span>
      </SectionTitle>
      <div className="mt-10 grid items-stretch gap-4 md:grid-cols-2" data-id="element-118" data-mp="2ur9w087p5qf1">
        {fullTestimonials.map((item, index) => <article key={item.initials + item.name} className={`relative flex flex-col rounded-2xl border bg-surface p-6 ${index === 0 ? 'border-gold/40 md:col-span-2' : 'border-line'}`} data-id="element-119" data-mp="9yy6hmot38zw" data-mpi={index}>
            <QuoteIcon aria-hidden="true" className="absolute right-5 top-5 h-8 w-8 text-gold/20" data-id="element-120" data-mp="2yb9c4ov4pm43" />
            <p className="mb-4 text-sm text-gold" aria-label="5 de 5 estrellas" data-id="element-121" data-mp="2uapg5omakojj">
              ★★★★★
            </p>
            <blockquote className={`mb-6 flex-1 font-medium italic leading-relaxed text-zinc-200 ${index === 0 ? 'text-lg md:text-xl' : 'text-base'}`} data-id="element-122" data-mp="2p99xg37l6u4b">
              “{item.text}”
            </blockquote>
            <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-123" data-mp="2al5jtdne58se">
              <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10 text-sm font-bold text-gold" data-id="element-124" data-mp="26jttt70luljo">
                {item.initials}
              </span>
              <div data-id="element-125" data-mp="1rnm9m6p75k4e">
                <p className="text-sm font-bold text-white" data-id="element-126" data-mp="1rn2raovmwtpu">{item.name}</p>
                <p className="text-xs text-zinc-400" data-id="element-127" data-mp="1i005exl4hyss">📍 {item.place}</p>
              </div>
            </div>
          </article>)}
      </div>
      <div className="mx-auto mt-10 max-w-3xl rounded-3xl border border-gold/40 bg-surface p-6 text-center" data-id="element-128" data-mp="1n0efsma75ktz">
        <p className="text-xl font-black leading-tight text-white md:text-2xl" data-id="element-129" data-mp="190v7nthdy9ho">
          Ellas ya no improvisan los domingos.{' '}
          <span className="text-gold" data-id="element-130" data-mp="20q833061zx1l">Tu turno empieza hoy.</span>
        </p>
        <div className="mt-5" data-id="element-131" data-mp="20sb40f8qval3">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:text-base" data-id="element-132" data-mp="25p1iiy4why4e">
            🎀 Quiero los mismos resultados en mis clases →
          </Button>
        </div>
      </div>
    </section>;
}